export default __webpack_public_path__ + "static/media/date-start.9f067be4.svg";